import { getProcoreZone, getProviderParams } from '@procore/web-sdk-env-utils'
import { FeatureToggleProvider } from '@procore/web-sdk-feature-toggle'
import type { ReactElement } from 'react'
import React, { useId, useMemo, useRef } from 'react'

const LAUNCH_DARKLY_KEYS: Record<string, string> = {
  development: '570f37b4eee8b907140070c5',
  staging: '570f2f6e348a2806d7006b6f',
  production: '570e9423348a2806d7004354',
}

const getEnvironment = () =>
  getProcoreZone(globalThis.location.hostname)?.environment

export function FeatureFlagProvider({
  children,
}: Readonly<{ children: ReactElement }>) {
  const { companyId, projectId } = getProviderParams()
  const environment = getEnvironment()
  const idRef = useRef(useId())

  const context = useMemo(
    () => ({ user: { email: idRef.current, projectId, companyId } }),
    [projectId, companyId]
  )

  return (
    <FeatureToggleProvider
      apiKey={LAUNCH_DARKLY_KEYS[environment]}
      context={context}
    >
      {children}
    </FeatureToggleProvider>
  )
}
